export const ESIM_DESTINATIONS_TYPE = {
  country: 'COUNTRY',
  region: 'REGION',
  global: 'GLOBAL'
}
